module.exports = __webpack_public_path__ + "1df11e881dfc72b77b8c04bd1de3d270.svg";